'use client'

import { CardText } from '@morpho-org/ui-v6/server'

import { ErrorDataUnavailable } from '@/components/common/Error'
import { useIsMedium } from '@/hooks/useBreakpoints'

const ApyCardMarketError = () => {
  const isMedium = useIsMedium()

  return (
    <div data-testid="market-apy-card-error" className="contents">
      <ErrorDataUnavailable minHeight="395px" />
      {isMedium && <CardText height="166px" text="An error has been encountered" />}
    </div>
  )
}

export default ApyCardMarketError
